import { oneOf } from 'prop-types'

const PLACEMENTS = ['top', 'bottom']

export const PROP_TYPE_PLACEMENT = oneOf(PLACEMENTS)
